<template>
  <sc-card
    class="page-logs-tracking-event-header-order"
    v-if="showBox">
    <template slot="header">
      <h2 class="has-text-primary is-size-4 card-header-title">
        {{ event.orders.length }} Pedido(s)
      </h2>
    </template>

    <template slot="body">
      <sc-carousel
        class="page-logs-tracking-event-header-order__orders-slider"
        :options="sliderOrdersOptions">

        <sc-carousel-slide
          class="page-logs-tracking-event-header-order__orders-slider-slide"
          v-for="order in event.orders"
          :key="order.shipment_order_number">
          <div class="page-logs-tracking-event-header-order__orders-slider-slide-item">
            <p
              class="heading"
              v-if="order.shipment_order_number">
              <strong>Número do pedido:</strong>
              <sc-tooltip label="Visualizar o pedido">
                <a
                  :href="`ng#/order-number/${order.shipment_order_number}/`"
                  target="_blank">
                  {{ order.shipment_order_number }}
                </a>
              </sc-tooltip>
            </p>

            <div
              class="page-logs-tracking-event-header-order__volumes-card"
              v-if="order.volumes.length">
              <h2
                class="page-logs-tracking-event-header-order__volumes-card-title has-text-primary is-size-5 has-text-centered">
                {{ order.volumes.length }} Volume(s)
              </h2>

              <sc-carousel
                class="page-logs-tracking-event-header-order__volumes-slider"
                ref="volumes"
                :options="sliderVolumesOptions">
                <sc-carousel-slide
                  v-for="volume in order.volumes"
                  :key="volume.volume_number">
                  <p
                    class="heading"
                    v-if="volume.volume_number">
                    <strong>Volume:</strong>
                    <span>{{ volume.volume_number }}</span>
                  </p>

                  <p
                    class="heading"
                    v-if="volume.invoice_number">
                    <strong>Nota fiscal:</strong>
                    <span>{{ volume.invoice_number }}</span>
                    <strong>Série:</strong>
                    <span>{{ volume.invoice_serie }}</span>
                  </p>

                  <p class="heading"
                     v-if="volume.invoice_key">
                    <strong>Chave da nota:</strong>
                    <span>{{ volume.invoice_key }}</span>
                  </p>

                  <p
                    class="heading"
                    v-if="volume.tracking_code">
                    <strong>Código de rastreamento:</strong>
                    <span>{{ volume.tracking_code }}</span>
                  </p>
                </sc-carousel-slide>

                <div
                  class="page-logs-tracking-event-header-order__volumes-slider__button-prev"
                  slot="button-prev">
                  <sc-icon icon="chevron-left" />
                </div>
                <div
                  class="page-logs-tracking-event-header-order__volumes-slider__button-next"
                  slot="button-next">
                  <sc-icon icon="chevron-right" />
                </div>
              </sc-carousel>
            </div>
          </div>
        </sc-carousel-slide>

        <div
          class="page-logs-tracking-event-header-order__orders-slider__button-prev"
          slot="button-prev">
          <sc-icon icon="chevron-up" />
        </div>
        <div
          class="page-logs-tracking-event-header-order__orders-slider__button-next"
          slot="button-next">
          <sc-icon icon="chevron-down" />
        </div>
      </sc-carousel>
    </template>
  </sc-card>
</template>

<script>
  import {
    ScCard,
    ScCarousel,
    ScCarouselSlide,
    ScIcon,
    ScTooltip,
  } from '@intelipost-js/secure-components';
  import { createNamespacedHelpers } from 'vuex';

  const { mapState } = createNamespacedHelpers('analytic/logsTracking');

  export default {
    name: 'sc-logs-tracking-detail-header-order',
    data() {
      return {
        sliderOrdersOptions: {
          direction: 'vertical',
          simulateTouch: false,
          navigation: {
            nextEl: '.page-logs-tracking-event-header-order__orders-slider__button-next',
            prevEl: '.page-logs-tracking-event-header-order__orders-slider__button-prev',
          },
        },
        sliderVolumesOptions: {
          simulateTouch: false,
          navigation: {
            nextEl: '.page-logs-tracking-event-header-order__volumes-slider__button-next',
            prevEl: '.page-logs-tracking-event-header-order__volumes-slider__button-prev',
          },
        },
      };
    },
    computed: {
      ...mapState([
        'event',
      ]),
      showBox() {
        return this.event.orders.length > 0;
      },
    },
    components: {
      ScCard,
      ScCarousel,
      ScCarouselSlide,
      ScIcon,
      ScTooltip,
    },
  };
</script>

<style lang="scss" scoped>
  @import "~@intelipost-js/secure-ui/src/scss/variables"; // eslint-disable-line

  .page-logs-tracking-event-header-order {
    position: relative;
    height: 100%;

    &__orders-slider{
      position: initial;
      height: 145px;

      &-slide{
        display: flex;
        flex-direction: column;
      }

      &__button-prev,
      &__button-next{
        position: absolute;
        top: 16px;
        font-size: 16px;
        cursor: pointer;
        outline: none;
        &.swiper-button-disabled{
          opacity: .5;
          cursor: default;
          &:hover{
            color: #4a4a4a;
          }
        }
        &:hover{
          color: $primary;
        }
      }
      &__button-prev{
        right: 3rem;
      }
      &__button-next{
        right: 0.75rem;
      }
    }

    &__volumes-card{
      position: relative;
      border: 1px solid $grey-lighter;
      padding: 0.5rem;
      &-title{
        padding-bottom: .5rem;
        margin-bottom: .5rem;
        border-bottom: 1px solid $grey-lighter;
      }
    }

    &__volumes-slider{
      position: initial;
      &__button-prev,
      &__button-next{
        position: absolute;
        top: 0.8rem;
        font-size: 16px;
        cursor: pointer;
        outline: none;
        &.swiper-button-disabled{
          opacity: .5;
          cursor: default;
          &:hover{
            color: initial;
          }
        }
        &:hover{
          color: $primary;
        }
      }
      &__button-prev{
        left: .5rem;
      }
      &__button-next{
        right: .5rem;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-analytic/features/logs/pages/tracking/pages/logs-tracking-detail/components/sc-logs-tracking-detail-header/blocks/sc-logs-tracking-detail-header-order/ScLogsTrackingDetailHeaderOrder.vue?15dc55f2